export const typographyColors = {
  text_primary: '#fff',
  text_secondary: 'rgba(255,255,255,0.72)',
  text_secondary_hover: 'rgba(255,255,255,0.85)',
  text_tertiary: 'rgba(255,255,255,0.56)',
  text_disabled: 'rgba(255,255,255,0.42)',
  text_link: '#8AB4FF',
  text_link_secondary: '#1877F2',
} as const
